
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import { isNull } from '@/utils/common'
import router from '../router'
import http from '@/utils/http/index'

export default {
  components: {
    XHeader,
    Group,
    XButton,
    XInput
  },
  data () {
    return {
      pageTitle: '登录',
      accountsVal: '', // 程乾
      passwordVal: '', // 123
      isLogin: false
    }
  },
  mounted () {
    if (this.$store.state.token.length > 0) {
      this.isLogin = true
    } else {
      this.isLogin = false
    }
  },
  methods: {
    goLogin () {
      // this.$store.commit('login', {
      //   accounts: this.accountsVal,
      //   password: this.passwordVal
      // })
      if (isNull(this.accountsVal) || isNull(this.passwordVal)) {
        this.$vux.toast.text('请输入用户名密码', 'top')
        return
      }
      const url = this.$store.state.url + '/wechat/login/bindingWithMicroServe'
      const params = {
        openid: this.$store.state.openId,
        accounts: this.accountsVal,
        password: this.passwordVal
      }
      http.post(url, params).then((response) => {
        if (response.data.success === true) {
          // contexts.state.isLogin = true
          // contexts.state.userInfo = response.data.account
          // contexts.state.token = response.data.token
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setUserInfo', response.data.account)
          this.$store.commit('setTokenVal', response.data.token)
          router.push({ name: 'Home' })
        } else if (response.data.success === false) {
          this.$vux.toast.text(response.data.msg, 'top')
          this.$store.commit('setIsLogin', false)
        }
      })
      // this.$store.dispatch(
      //   'login', {
      //     accounts: this.accountsVal,
      //     password: this.passwordVal
      //   }
      // )
    },
    goLogout () {
      this.$store.commit('logout', {})
      this.accountsVal = ''
      this.passwordVal = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Login.vue